import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiTermsConditionService {
    apiBase: string = '/api/users';

    constructor(private readonly httpClient: HttpClient) { }

    saveTermsCondition(loggedLicenseDetails: any): Observable<any> {
        return this.httpClient.patch<any>(`${this.apiBase}/accept-terms`, loggedLicenseDetails);
    }
}
